'use client';
import React, { useState } from 'react';
import { Dialog } from '@headlessui/react';
import { BaseImage } from '@/components/baseImage/BaseImage';
import { ImageContentProps } from '@/components/image-content/types';
import Icon from '@/components/icon/Icon';

export const ImageContent: React.FC<ImageContentProps> = ({ image }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { imageDescription, ...baseImageProps } = image;

  const openModal = () => setIsModalOpen(true);
  const closeModal = () => setIsModalOpen(false);

  return (
    <>
      {/* Image Display */}
      <div
        className="image-content-element w-full cursor-pointer"
        onClick={openModal}
      >
        <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
          <div className="col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-3 lg:col-end-11 xl:col-start-4 xl:col-end-10">
            <BaseImage
              {...baseImageProps}
              className="w-full overflow-hidden rounded-lg"
              classNameImage="w-full"
              sizes="(max-width: 1024px) 100vw, (max-width: 1280px) 66vw, 50vw"
            />
          </div>
        </div>
      </div>

      {/* Modal */}
      <Dialog open={isModalOpen} onClose={closeModal} className="relative z-50">
        {/* Overlay */}
        <div
          className="fixed inset-0 bg-black bg-opacity-50"
          aria-hidden="true"
        />

        {/* Modal Content */}
        <div className="fixed inset-0 flex items-center justify-center p-4">
          <Dialog.Panel className="relative w-full max-w-5xl rounded-lg bg-white shadow-lg">
            <button
              onClick={closeModal}
              className="absolute right-4 top-4 text-gray-600 focus:outline-none"
              aria-label="Close"
            >
              <Icon name="x" size="24px" color="gray" />
            </button>
            <div className="p-4">
              <BaseImage
                {...baseImageProps}
                className="w-full overflow-hidden rounded-lg"
                classNameImage="w-full"
                sizes="(max-width: 1024px) 100vw, 1024px"
              />
              {imageDescription && (
                <p className="mt-4 text-center text-gray-600">
                  {imageDescription}
                </p>
              )}
            </div>
          </Dialog.Panel>
        </div>
      </Dialog>
    </>
  );
};
